import { Pill } from "@atlas/ui/web";
import type { CredorTipo } from "@atlas/sdk";

/**
 * QUEM E' O CREDOR deste contrato — o que a averbadora pediu para ver em
 * contratos e ADF (10/09/2026): parceiro e' a consignataria que opera na
 * plataforma; o valor `consignataria` e' a que so' recebe repasse — rotulada
 * "Sem acesso" desde 11/10/2026, quando "consignataria" virou o nome da persona;
 * "a identificar" e' a obrigacao legada cuja verba ainda nao tem credor ligado
 * (ADR-0010). Os VALORES nao mudaram, so' os rotulos.
 */
export const CREDOR_TIPO_LABEL: Record<CredorTipo, string> = {
  parceiro: "Parceira",
  consignataria: "Sem acesso",
  a_identificar: "A identificar",
};

export const CREDOR_TIPO_TITLE: Record<CredorTipo, string> = {
  parceiro: "Consignatária cadastrada que opera na plataforma: vê a carteira e averba.",
  consignataria: "Credor cadastrado só para receber repasse: não acessa a plataforma.",
  a_identificar: "A verba está classificada, mas nenhum credor foi ligado ainda. O convênio liga.",
};

export function CredorTipoPill({ tipo }: { tipo: CredorTipo | undefined }) {
  if (!tipo) return null;
  const variant = tipo === "parceiro" ? "aceita" : tipo === "consignataria" ? "emdia" : "pendente";
  return (
    <span title={CREDOR_TIPO_TITLE[tipo]}>
      <Pill variant={variant}>{CREDOR_TIPO_LABEL[tipo]}</Pill>
    </span>
  );
}
